import { ReactElement, useMemo } from 'react';
import Hypher from 'hypher';
import english from 'hyphenation.en-us';
import german from 'hyphenation.de';
import italian from 'hyphenation.it';
import french from 'hyphenation.fr';
import { useTranslation } from 'react-i18next';

const hypers = {
  en: new Hypher(english),
  de: new Hypher(german),
  it: new Hypher(italian),
  fr: new Hypher(french)
} as const;

interface HyphenatedTextProps extends React.HTMLAttributes<HTMLParagraphElement> {
  children: string;
}

const HyphenatedText = ({ children, ...props }: HyphenatedTextProps): ReactElement => {
  const { i18n } = useTranslation();

  const hyphenatedText = useMemo(() => {
    const hyper = hypers[i18n.language as keyof typeof hypers] || hypers.en;
    try {
      return hyper.hyphenateText(children);
    } catch (error) {
      console.warn('Failed to hyphenate text:', error);
      return children;
    }
  }, [children, i18n.language]);

  return <p {...props}>{hyphenatedText}</p>;
};

export default HyphenatedText;
